module.exports = __webpack_public_path__ + "static/images/solution.a07847e1d4fc60363f2ae6183be26cbb.jpg";